import React from 'react'

export default function dynamic<T extends React.ComponentType<any>>(
  loader: () => Promise<{ default: T } | T>,
  _options?: any
): React.LazyExoticComponent<T> {
  // Map next/dynamic to React.lazy on the client
  return React.lazy(loader as any)
}
